import React, { useState } from "react";
import styles from "./index.module.css";
import {
  Grid,
  Hidden,
} from "@material-ui/core";
import Sidebar from "./sidebar";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import SendMail from './SendMail';
import ManageUser from './ManageUser';

const Index = () => {
  return (
    <Router>
      <Grid container>
        <Hidden mdDown>
          <Grid item lg={3} className={styles.sidebarWrapper}>
            <Sidebar />
          </Grid>
        </Hidden>
        <Grid item lg={9}>
          <Switch>
            <Route exact path="/utilities" component={SendMail} />
            <Route exact path="/utilities/manage_user/" component={ManageUser} />
           
          </Switch>
        </Grid>
      </Grid>
    </Router>
  );
};

export default Index;
